const actions = {
  GET_USER_REQUEST: "GET_USER_REQUEST",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_ERROR: "GET_USER_ERROR",
  getUser: (token, id) => {
    return {
      type: actions.GET_USER_REQUEST,
      token,
      id
    };
  }
};

const userActions = actions;

export default userActions;
